'use client';

import { FC } from 'react';
import { useContentfulInspectorMode } from '@contentful/live-preview/react';
import CustomImage from '@/components/CustomImage/CustomImage';

interface LeaderCardProps {
    id: string;
    image: string;
    name: string;
    position: string;
    onModalOpen: () => void;
    hidePreview?: boolean;
    imageAlt?: string;
}

const LeaderCard: FC<LeaderCardProps> = ({
    id,
    image,
    name,
    position,
    onModalOpen,
    hidePreview = false,
    imageAlt,
}) => {
    const inspectorProps = useContentfulInspectorMode({ entryId: id });

    return (
        <div
            className="tw-max-w-[344px] tw-bg-white tw-pb-[20px] tw-justify-self-center tw-cursor-pointer"
            onClick={() =>
                window.dataLayer &&
                window.dataLayer.push({
                    event: 'leadership_profile',
                    people: name.toLowerCase().split(' ').join('_'),
                })
            }
        >
            <div
                onClick={onModalOpen}
                className="tw-w-full tw-overflow-hidden h-[180px]  md:tw-h-[185px]  lg:tw-h-[270px] tw-border-br-50 lg:tw-border-br-80 tw-relative"
            >
                <CustomImage
                    src={image}
                    alt={imageAlt ?? name}
                    className="tw-w-full tw-h-[160px] sm:tw-h-[180px] md:tw-h-full tw-object-cover"
                    width={344}
                    height={180}
                    {...(hidePreview
                        ? {}
                        : inspectorProps({
                              fieldId: 'picture',
                          }))}
                />
                <div className="tw-absolute tw-bottom-[5px]  lg:tw-bottom-[10px]  tw-left-[5px] lg:tw-left-[10px] hover:tw-bottom-[7px] lg:hover:tw-bottom-[12px] tw-transition-all tw-duration-1500">
                    <CustomImage
                        src={'/images/user-more.svg'}
                        alt={name}
                        className="tw-w-[35px] tw-h-[35px] lg:tw-w-[50px] lg:tw-h-[50px]"
                        width={35}
                        height={35}
                    />
                </div>
            </div>
            <div className="">
                <h2
                    className="tw-text-[#4B4F54E6] tw-pt-[10px] tw-font-gotham tw-font-bold tw-pb-[5px] tw-text-[12px] lg:tw-text-[15px]"
                    {...(hidePreview
                        ? {}
                        : inspectorProps({
                              fieldId: 'name',
                          }))}
                >
                    {name}
                </h2>
                <p
                    className="tw-text-[#4B4F54E6] tw-font-gotham-book tw-font-normal tw-text-[11px] lg:tw-text-[12px]"
                    {...(hidePreview
                        ? {}
                        : inspectorProps({
                              fieldId: 'position',
                          }))}
                >
                    {position}
                </p>
            </div>
        </div>
    );
};

export default LeaderCard;
